import { render, staticRenderFns } from "./LotteryCircle.vue?vue&type=template&id=0b088d57&scoped=true&"
import script from "./LotteryCircle.vue?vue&type=script&lang=js&"
export * from "./LotteryCircle.vue?vue&type=script&lang=js&"
import style0 from "./LotteryCircle.vue?vue&type=style&index=0&id=0b088d57&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b088d57",
  null
  
)

export default component.exports